import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'RechargeModal',
  category: '💬 Chat',
  description: 'Modal de recarga de créditos com suporte a cartão salvo, novo cartão e PIX com QR Code.',
  usedIn: ['ChatHubPage'],
  example: () => (
    <div style={{ padding: 16, fontSize: 13, color: T.textMuted }}>
      RechargeModal é um modal fullscreen — renderiza via signal showRechargeModal.
      <br />Suporta: seleção de valor ($5/$10/$25/$50), cartão salvo, novo cartão, PIX com QR code e polling.
    </div>
  ),
};
